export default __webpack_public_path__ + "static/media/icons8-services.08684857.svg";